function Buttonu() {
  return (
    <>
      <button className="bg-[#212529] text-white block w-24 text-center rounded-xl my-4 py-2 px-4">Hire Me</button>
    </>
  );
}
export default Buttonu;
